var Utils = {

  addTerms(terms, translations) {
    translations.reduce((acc, item) => {
      acc[item.term] = item.definition
      return acc
    }, terms)
  },

  mapToHash: function(map) {
    var hash = "#"
    for (var key in map) {
      hash += key + '=' + map[key] + ';'
    }
    return hash
  },

  hashToMap: function() {
    var hash = window.location.hash.replace('#', '')
    return hash.split(';').reduce((acc, value) => {
      var pair = value.split('=')
      if (pair.length === 2) {
        acc[pair[0]] = pair[1]
      }

      return acc
    }, {})
  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/Utils.js